module.exports = __webpack_public_path__ + "img/service_3.6cd5658.webp";